module.exports = __webpack_public_path__ + "static/guillen-e2bf80b332f587d21d77d1f31d70709b.png";